import {
  Table,
  Dialog,
  Button,
  Divider,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
} from '@mui/material';
import { TransactionStatus } from 'src/type/transaction';
import Label from 'src/components/label';
import { fNumber } from 'src/utils/format-number';
import { fDate } from 'src/utils/format-time';
import InfoGrid from 'src/components/ui-kit/info-grid';
import { DepositTxType } from 'src/type/deposit';
import { statusAction } from './utils';
import { txStatusLabel } from '../__gold-withdraw/utils';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  tx: DepositTxType;
};

export default function DepositViewDialog({ open, onClose, tx }: Props) {
  const getInfo = () => {
    if (!tx) return [];

    const {
      status,
      createdAt,
      updatedAt,
      user,
      branch,
      note,
      depositCostPerUnit,
      depositReceiptNo,
      ticketCreatedAt,
      ticketNumber,
      // remainGoldAmount,
    } = tx;

    const fullName = user?.firstName
      ? `${user.firstName}${user.lastName ? ` ${user.lastName}` : ''}`
      : '';

    const displayName = fullName || user?.email || '-';

    return [
      {
        label: 'สถานะ',
        value: (
          <Label
            variant="soft"
            color={
              (status === TransactionStatus.SUCCESS && 'success') ||
              (status === TransactionStatus.PENDING && 'warning') ||
              (status === TransactionStatus.REJECTED && 'error') ||
              (status === TransactionStatus.CANCEL && 'info') ||
              'default'
            }
          >
            {txStatusLabel(status)}
          </Label>
        ),
      },
      {
        label: 'ผู้ใช้งาน',
        value: displayName,
      },
      { label: 'สาขา', value: branch.name },
      {
        label: 'ราคาต่อหน่วย (ณ วันที่ทำรายการ)',
        value: `${fNumber(depositCostPerUnit || 0)} THB`,
      },
      { label: 'วันที่ทำรายการ', value: fDate(createdAt, 'DD MMMM BBBB HH:mm น.') },
      ...([TransactionStatus.SUCCESS, TransactionStatus.REJECTED].includes(status)
        ? [
            {
              label: `วันที่${statusAction(status)}`,
              value: fDate(updatedAt, 'DD MMMM BBBB HH:mm น.'),
            },
          ]
        : []),
      ...(depositReceiptNo
        ? [
            {
              label: 'เลขที่ใบเสร็จ',
              value: depositReceiptNo,
            },
          ]
        : []),
      ...(ticketNumber
        ? [
            {
              label: 'เลขที่ตั๋ว',
              value: ticketNumber,
            },
          ]
        : []),
      ...(ticketCreatedAt
        ? [
            {
              label: 'วันที่ออกตั๋ว',
              value: fDate(ticketCreatedAt, 'DD MMMM BBBB HH:mm น.'),
            },
          ]
        : []),
      {
        label: 'หมายเหตุ',
        value: note || '-',
      },
    ];
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={{ pb: 2, display: 'flex' }}>
        ฝากสินค้า
        {tx.product.name} {tx.amount} {tx.unitName}
      </DialogTitle>

      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell align="center">น้ำหนัก</TableCell>
                <TableCell align="center">จำนวน</TableCell>
                {/* <TableCell align="center">คงเหลือ</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {tx?.productRedeemFees?.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item?.productRedeemFee?.name}</TableCell>
                  <TableCell align="center">
                    {item?.productRedeemFee?.weight} {item?.productRedeemFee?.unitName}
                  </TableCell>
                  <TableCell align="center">{fNumber(item?.amount || 0)}</TableCell>
                  {/* <TableCell align="center">{fNumber(0)} บาท</TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Divider style={{ borderStyle: 'dashed' }} />

          <Table size="small" sx={{ mt: 3 }}>
            <TableHead>
              <TableRow>
                <TableCell>น้ำหนักทองทั้งหมด</TableCell>
                <TableCell align="center">
                  {fNumber(tx?.amount || 0)} {tx.unitName}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>ค่าธรรมเนียมทั้งหมด</TableCell>
                <TableCell align="center">{fNumber(tx?.fee || 0)} THB</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>จำนวนทองคงเหลือ</TableCell>
                <TableCell align="center">
                  {fNumber(tx?.remainGoldAmount || 0)} {tx.unitName}
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
        <InfoGrid infos={getInfo()} />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
